import {StrictMode} from 'react';
import {createRoot, hydrateRoot} from 'react-dom/client';
import App from './App.jsx';
import './index.css';
import {getCurrentPath, normalizePath} from './utils/path.js';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('React root element was not found.');
}

const app = (
  <StrictMode>
    <App />
  </StrictMode>
);

const renderedPath = rootElement.dataset.prerenderedPath;
const currentPath = getCurrentPath();
const canHydrate = (
  rootElement.hasChildNodes() &&
  renderedPath &&
  normalizePath(renderedPath) === currentPath
);

if (canHydrate) {
  hydrateRoot(rootElement, app);
} else {
  if (rootElement.hasChildNodes()) {
    rootElement.replaceChildren();
  }

  createRoot(rootElement).render(app);
}